module.exports = __webpack_public_path__ + "static/img/food-policy02.8051bf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/food-policy02.png
// module id = v+Sj
// module chunks = 1